import React from 'react';
import './HomePage.css'

const HomePage = () => {
    return (
        <div className='right-content'>
            <div className='card shadow border-0'>
                <div className="row d-flex align-items-center w-100">
                    <div className="col">
                        <h1 className='hd'>Выберите раздел в панели слева...</h1>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomePage;